import {FILES_FORMATION_DOC_POST} from "../axios";

export const axiosPostFormationTemplate = async (axiosPrivate, docId, templateId, setDocument) => {
    try {
        const response = await axiosPrivate.post(FILES_FORMATION_DOC_POST + `?doc_id=${docId}&template_id=${templateId}`)
        setDocument(response.data)
    } catch (err) {
        // navigate('/auth', {state: {from: location}, replace: true})
        // logout();
        console.error(err);
    }
}